/*************************************************/
/* 3rd Party                                     */
/*************************************************/

// Passive event listeners
document.addEventListener('touchstart', () => { }, { passive: true });
document.addEventListener('touchmove', () => { }, { passive: true });


/*************************************************/
/* Partials                                      */
/*************************************************/

import { intersectionObservation } from "./partials/intersectionObservation.js";
import { header } from "./partials/header.js";
import { language } from "./partials/language.js";
import { menu } from "./partials/menu.js";
import { search } from "./partials/search.js";
import { searchbar } from "./partials/searchbar.js";
import { video } from "./partials/video.js";
import { modal } from "./partials/modal.js";
import { cookies } from "./partials/cookies.js";
import { accordion } from "./partials/accordion.js";
import { collapsedText } from "./partials/collapsedText.js";
import { slider } from "./partials/slider";
import { calendar } from "./partials/calendar.js";
import { employees } from "./partials/employees.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {

    document.querySelector('#skipLink').addEventListener('click',e => {
        document.querySelector('#mainContent').focus();
    });

    const body = document.querySelector('body');
    const bodyLoadingClass = 'is-loading';
    
    intersectionObservation();
    header(body);
    language();
    menu();
    search();
    searchbar(body);
    modal(body, bodyLoadingClass);
    video();
    cookies();
    accordion();
    slider();
    collapsedText();
    calendar();
    employees();
});
